module.exports = __webpack_public_path__ + "assets/img/mecha-btn-608e2411.png";